/**************************************************
 * Nombre:       Formulario_Codigo_Descuento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {
    AccountCircleOutlined,
    CakeOutlined,
    LocalOfferOutlined,
    Mail,
    PhoneAndroid,
    TagOutlined,
    WhatsApp
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";


const Formulario_Codigo_Descuento = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12}>
                    <IngresoTexto Icono={LocalOfferOutlined} nombre={'Codigo de Cupon'}
                                  dato={'codigo'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Codigo_Descuento